import { render, staticRenderFns } from "./Kontak.vue?vue&type=template&id=163110c3&"
import script from "./Kontak.vue?vue&type=script&lang=js&"
export * from "./Kontak.vue?vue&type=script&lang=js&"
import style0 from "./Kontak.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports